import { render, staticRenderFns } from "./FreightForwardingReport.vue?vue&type=template&id=391e83f8&scoped=true&"
import script from "./FreightForwardingReport.vue?vue&type=script&lang=js&"
export * from "./FreightForwardingReport.vue?vue&type=script&lang=js&"
import style0 from "./FreightForwardingReport.vue?vue&type=style&index=0&id=391e83f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e83f8",
  null
  
)

export default component.exports